<template>
  <section style="padding-left: 25px; margin-left: 20px; padding-right: 10px; margin-right: 10px">
    <!-- Loader -->
    <div v-if="loading" class="d-flex justify-center align-center" style="height: 200px">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>
    <div v-else>
      <div v-for="(item, index) in actualityData" :key="index" style="margin-bottom: 40px">
        <v-card class="mb-6 ml-6 mt-6 mr-2">
          <v-card-title>{{ item.actualityType }} : {{ item.actualityTitle }}</v-card-title>
        </v-card>

        <div style="display: flex; justify-content: space-around; margin-bottom: 20px">
          <div style="text-align: center">
            <!-- Display circles  iOS  -->

            <div style="
              width: 100px;
              height: 100px;
              border-radius: 50%;
              background-color: #a3a4a2;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;

              margin-left: 100px;
            ">
              {{ item.totalNumberIos }}
              iOS
            </div>
            <!-- Bar chart for iOS success and failure -->
            <div id="chart-ios">
              <apexchart type="bar" height="280" :options="getChartOptions()" :series="getIosSeries(item)"></apexchart>
            </div>
          </div>

          <div style="text-align: center">
            <!-- Display circles  Android  -->

            <div style="
              width: 100px;
              height: 100px;
              border-radius: 50%;
              background-color: #a3a4a2;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;
              margin-left: 100px;
            ">
              {{ item.totalNumberAndroid }} Android
            </div>
            <!-- Bar chart for Android success and failure -->
            <div id="chart-android">
              <apexchart type="bar" height="280" :options="getChartOptions()" :series="getAndroidSeries(item)">
              </apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Pagination -->
    <div class="text-center">
      <v-pagination v-model="currentPage" :length="totalPages" @input="handlePageChange"
        :total-visible="7"></v-pagination>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import Constant from "@/utils/constants";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      actualityData: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0,
      loading: false,
    };
  },
  methods: {
    //afficher donne ios
    getIosSeries(item) {
      return [
        {
          name: "iOS",
          data: [item.successIos, item.failureIos],
        },
      ];
    },
    //afficher donne android

    getAndroidSeries(item) {
      return [
        {
          name: "Android",
          data: [item.successAndroid, item.failureAndroid],
        },
      ];
    },
    //afficher donne Chart Bar
    getChartOptions() {
      return {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        colors: ["#86d527", "#f44336"], // Green for success, Red for failure

        xaxis: {
          categories: ["Success", "Failure"],
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
      };
    },

    async getAllNotification() {
      this.loading = true;
      try {
        const response = await axios.post(Constant.QORANI + "notificationState/getallPaginate", {
          pageNumber: this.currentPage - 1,
          pageSize: this.pageSize
        });
        this.actualityData = response.data.notificationStateResponseList;
        this.totalItems = response.data.totalNbrElement;
        this.totalPages = response.data.nbrTotalPage;
      } catch (error) {
        console.error("Error fetching notification:", error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.getAllNotification();
    },
  },
  mounted() {
    this.getAllNotification();
  },
};
</script>
<style lang="css"></style>
